/// <reference types="user-agent-data-types" />

/**
 * WARNING: This function makes a lot of assumptions about the user agent string
 * and may not be accurate for all browsers, it's the best we cna do without
 * installing global Sentry integrations or taking on bloated npm modules
 *
 * @link https://develop.sentry.dev/sdk/data-model/event-payloads/contexts/#os-context
 * @param {Navigator} navigator
 * @returns {Object}
 */
export const getOSContext = (navigator: Navigator) => {
  const ua = navigator.userAgent;
  let osName = 'Unknown';
  let osVersion = 'Unknown';

  // Windows OS detection
  if (/Windows NT/.test(ua)) {
    osName = 'Windows';
    const versionMatch = ua.match(/Windows NT ([\d.]+)/);
    if (versionMatch) {
      switch (versionMatch[1]) {
        case '10.0':
          osVersion = '10';
          break;
        case '6.3':
          osVersion = '8.1';
          break;
        case '6.2':
          osVersion = '8';
          break;
        case '6.1':
          osVersion = '7';
          break;
        case '6.0':
          osVersion = 'Vista';
          break;
        case '5.1':
        case '5.2':
          osVersion = 'XP';
          break;
        default:
          osVersion = versionMatch[1] || 'Unknown';
      }
    }
  }
  // iOS detection (for Safari mobile)
  else if (/iPhone|iPad|iPod/.test(ua)) {
    osName = 'iOS';
    const versionMatch = ua.match(/OS ([\d_]+)/);
    if (versionMatch) {
      osVersion = versionMatch[1]?.replace(/_/g, '.') || 'Unknown';
    }
  }
  // macOS detection
  else if (/Mac OS X/.test(ua)) {
    osName = 'macOS';
    const versionMatch = ua.match(/Mac OS X ([\d_]+)/);
    if (versionMatch) {
      osVersion = versionMatch[1]?.replace(/_/g, '.') || 'Unknown';
    }
  }
  // Android detection
  else if (/Android/.test(ua)) {
    osName = 'Android';
    const versionMatch = ua.match(/Android ([\d.]+)/);
    if (versionMatch) {
      osVersion = versionMatch[1] || 'Unknown';
    }
  }
  // Chrome OS detection
  else if (/CrOS/.test(ua)) {
    osName = 'Chrome OS';
    osVersion = 'Unknown'; // Chrome OS version is typically not provided in the UA string
  }
  // Linux detection
  else if (/Linux/.test(ua) && !/Android/.test(ua)) {
    osName = 'Linux';
    osVersion = 'Unknown'; // Linux versions aren't typically detailed in user agents
  }

  return {
    name: osName,
    version: osVersion,
  };
};
